import {
  HeadlineOne,
  SectionWrapper,
} from 'components/atoms/SectionWrapper.style';
import React from 'react';
import ContactIconsWrapper from 'components/organisms/formComponents/contactIconsWrapper/ContactIconsWrapper';
import styled from 'styled-components';
import Header from 'components/organisms/header/Header';
import ContactUs from 'components/organisms/formComponents/emailWrapper/ContactUs';
import Mapa from 'components/organisms/formComponents/maps/Maps';
import Map from 'components/organisms/formComponents/map/Map';
import AnimationLogo from 'components/organisms/header/AnimationLogo';
const EditHeadline = styled(HeadlineOne)`
  margin-top: 100px;
`;

const FormCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  text-align: center;

  /* 
  justify-content: center;
  flex-direction: column; */
  /* 
 */
`;

const Form = () => (
  <>
    {/* <FormImages /> */}
    <Header />
    <SectionWrapper>
      <FormCenter>
        <EditHeadline></EditHeadline>
        <ContactIconsWrapper />
        {/* <ContactUs /> */}
        {/* </FormCenter> */}

        <ContactUs />
      </FormCenter>
      <Map />
    </SectionWrapper>
  </>
);

export default Form;
